import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DeleteaccountPage } from './deleteaccount';

@NgModule({
  declarations: [
    DeleteaccountPage,
  ],
  imports: [
    IonicPageModule.forChild(DeleteaccountPage),
  ],
})
export class DeleteaccountPageModule {}



// WEBPACK FOOTER //
// ./src/pages/deleteaccount/deleteaccount.module.ts